/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { MasterButton, ModalExportList } from "App/Component/ui"
import {
  TaxIcon,
  FileOpenIcon,
  ShoppingCartIcon,
  DiscountIcon,
} from "App/Assets/index"
import { ModalSimpan, ModalPotongan, ModalTax, ModalBiaya } from ".."
import { useContext } from "react"
import { FormContext } from "../../context/FormContext"
import {
  exportItemPembelianLogistik,
  FORM_RESET_STATE_WMS_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
} from "../../helpers"
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
  removeLocalStorageAsFormData,
} from "App/utils/helpers"
import { BASE_URL_4, WMS_LGS_PEMBELIAN } from "App/constants"
import { Grid } from "@material-ui/core"
import { CloudDownload, FormatListBulleted } from "@material-ui/icons"

const useStyles = makeStyles({
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
})

export default function Perhitungan({
  setListPembelian,
  setNewDataPembelianList,
  listPembelian,
  menu,
  changeParentData,
  getListPembelian,
}) {
  const classes = useStyles()
  const [showModalSimpan, setShowModalSimpan] = useState(false)
  const [showModalPotongan, setShowModalPotongan] = useState(false)
  const [showModalTax, setShowModalTax] = useState(false)
  const [showModalBiaya, setShowModalBiaya] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showModalExportList, setShowModalExportList] = useState(false)

  const { formData, setFormData, KAS } = useContext(FormContext)

  const [perhitungan, setPerhitungan] = useState({
    sub_disc: 0,
    sub_total_tanpa_disc: 0,
    jumlah: 0,
    potongan: convertToValidPrice(formData.potongan2),
    sub_total_dikurangi_potongan: 0,
    tax: convertToValidPrice(formData.tax2),
    sub_total_plus_tax: 0,
    ongkos: convertToValidPrice(formData.ongkos2),
    biayalain: convertToValidPrice(formData.biayalain2),
    total_jumlah: 0,
    pembayaran: 0,
    sisa: 0,
  })

  function resetForm() {
    setFormData({
      ...FORM_RESET_STATE_WMS_PEMBELIAN,
      kasbank_id: KAS.kas_id,
      kasbank: KAS.kas_nama,
      coa_code: KAS.coa_code,
    })
    removeLocalStorageAsFormData(WMS_LGS_PEMBELIAN)
    setListPembelian([])

    if (menu === WMS_LGS_PEMBELIAN) {
      changeParentData("")
    }
  }

  async function getPerhitunganListPembelian() {
    let sub_disc = 0
    let sub_total_tanpa_disc = 0

    await listPembelian.map((e) => {
      const subJumlah = e?.harga_satuan * e?.qty
      const nilaiDisc = (parseFloat(e.disc) / 100) * subJumlah
      sub_disc += nilaiDisc
      sub_total_tanpa_disc += subJumlah

      return true
    })

    let jumlah = sub_total_tanpa_disc - sub_disc
    let sub_total_dikurangi_potongan =
      jumlah - convertToValidPrice(formData.potongan2)
    let tax =
      (convertToValidPrice(formData.tax2) / 100) * sub_total_dikurangi_potongan
    let sub_total_plus_tax = sub_total_dikurangi_potongan + tax
    let ongkos = convertToValidPrice(formData.ongkos2)
    let biayalain = convertToValidPrice(formData.biayalain2)
    let total_jumlah =
      sub_total_plus_tax + parseFloat(ongkos) + parseFloat(biayalain)
    let pembayaran = formData.pembayaran
    let sisa = total_jumlah - pembayaran

    setPerhitungan({
      sub_disc,
      sub_total_tanpa_disc,
      jumlah,
      potongan: convertToValidPrice(formData.potongan2),
      sub_total_dikurangi_potongan,
      tax,
      sub_total_plus_tax,
      ongkos,
      biayalain,
      total_jumlah,
      pembayaran,
      sisa,
    })
  }

  useEffect(() => {
    ;(async () => {
      await getPerhitunganListPembelian()
    })()
  }, [
    listPembelian,
    formData.potongan,
    formData.biayalain,
    formData.ongkos,
    formData.tax,
  ]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleExport = async (e) => {
      e.preventDefault()
      setIsLoading(true)
      try {
        const res = await exportItemPembelianLogistik(formData.id)
        if (res.state) {
          defaultToastSuccess("Berhasil, mohon menunggu data sedang dieksport...")
        } else {
          defaultToastError(res.message)
        }
  
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        defaultToastError(error?.response?.data?.message)
      }
    }
  

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          listPembelian={listPembelian}
          setShowModal={() => setShowModalSimpan(false)}
          setNewDataPembelianList={setNewDataPembelianList}
          getListPembelian={getListPembelian}
        />
      )}

      {showModalPotongan && (
        <ModalPotongan
          setShowModal={() => setShowModalPotongan(false)}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      )}

      {showModalTax && (
        <ModalTax
          setShowModal={() => setShowModalTax(false)}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      )}

      {showModalBiaya && (
        <ModalBiaya
          setShowModal={() => setShowModalBiaya(false)}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      )}

      <div>
        <p className="fw-600 mb-1 mt-1">Perhitungan</p>
      </div>

      <div>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <div>
              <table width="100%" className="table-perhitungan-pembelian-wms">
                <tbody>
                  <tr>
                    <td width="40%">Sub Total</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.sub_total_tanpa_disc)
                        ? 0
                        : formatNumber(perhitungan.sub_total_tanpa_disc)}
                    </td>
                  </tr>
                  <tr>
                    <td width="40%" className={`${classes.textRed}`}>
                      Sub Disc
                    </td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.sub_disc)
                        ? 0
                        : formatNumber(perhitungan.sub_disc)}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="2"></td>
                    <td colSpan="2" className={classes.border}></td>
                  </tr>

                  <tr>
                    <td width="40%" className="pt-1">
                      Jumlah
                    </td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.jumlah)
                        ? 0
                        : formatNumber(perhitungan.jumlah)}
                    </td>
                  </tr>

                  <tr>
                    <td width="40%" className={`${classes.textRed}`}>
                      Potongan
                    </td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.potongan)
                        ? 0
                        : formatNumber(perhitungan.potongan)}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="2"></td>
                    <td colSpan="2" className={classes.border}></td>
                  </tr>

                  <tr>
                    <td width="40%" className="pt-1">
                      Sub Total
                    </td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.sub_total_dikurangi_potongan)
                        ? 0
                        : isNaN(perhitungan.sub_total_dikurangi_potongan)
                        ? 0
                        : formatNumber(
                            perhitungan.sub_total_dikurangi_potongan,
                          )}
                    </td>
                  </tr>

                  <tr>
                    <td width="40%">Tax ({formData.tax}%)</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.tax)
                        ? 0
                        : isNaN(perhitungan.tax)
                        ? 0
                        : formatNumber(perhitungan.tax)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Grid>
          <Grid item sm={6}>
            <div>
              <table width="100%" className="table-perhitungan-pembelian-wms">
                <tbody>
                  <tr>
                    <td width="40%">Total</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.sub_total_plus_tax)
                        ? 0
                        : isNaN(perhitungan.sub_total_plus_tax)
                        ? 0
                        : formatNumber(perhitungan.sub_total_plus_tax)}
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">Biaya</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.biayalain)
                        ? 0
                        : formatNumber(perhitungan.biayalain)}
                    </td>
                  </tr>
                  <tr>
                    <td width="40%">Ongkos</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.ongkos)
                        ? 0
                        : formatNumber(perhitungan.ongkos)}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="2"></td>
                    <td colSpan="2" className={classes.border}></td>
                  </tr>

                  <tr>
                    <td width="40%">Total Jumlah</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.total_jumlah)
                        ? 0
                        : isNaN(perhitungan.total_jumlah)
                        ? 0
                        : formatNumber(perhitungan.total_jumlah)}
                    </td>
                  </tr>

                  <tr>
                    <td width="40%">Pembayaran</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.pembayaran)
                        ? 0
                        : formatNumber(perhitungan.pembayaran)}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="2"></td>
                    <td colSpan="2" className={classes.border}></td>
                  </tr>

                  <tr>
                    <td width="40%">Sisa</td>
                    <td width="5%">:</td>
                    <td width="5%">Rp. </td>
                    <td width="50%" align="right">
                      {isNull(perhitungan.sisa)
                        ? 0
                        : isNaN(perhitungan.sisa)
                        ? 0
                        : formatNumber(perhitungan.sisa)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Grid>
        </Grid>

        <div className="mt-1">
          <div
            className="mt-1"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {formData.status !== STATUS_SELESAI_PEMBELIAN && (
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                {formData?.id !== "" && (
                  <>
                    <MasterButton
                      type={"button"}
                      color="green"
                      name="Biaya"
                      onClick={() => setShowModalBiaya(!showModalBiaya)}
                      size="sm"
                      withIcon={true}
                      icon={<ShoppingCartIcon width="20px" height="20px" />}
                    />
                    <MasterButton
                      type={"button"}
                      color="green"
                      name="Potongan"
                      onClick={() => setShowModalPotongan(!showModalPotongan)}
                      size="sm"
                      withIcon={true}
                      icon={<DiscountIcon width="20px" height="20px" />}
                    />
                    <MasterButton
                      type={"button"}
                      color="green"
                      name="Tax"
                      onClick={() => setShowModalTax(!showModalTax)}
                      size="sm"
                      withIcon={true}
                      icon={<TaxIcon width="18px" height="21px" />}
                    />
                  </>
                )}
              </div>
            )}
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              {formData.status !== STATUS_SELESAI_PEMBELIAN && (
                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name="Simpan"
                  size="lg"
                  onClick={() => setShowModalSimpan(!showModalSimpan)}
                  withIcon={true}
                  icon={<TaxIcon width="12px" height="15px" />}
                />
              )}
              <MasterButton
                type={"button"}
                color="danger"
                name="Reset"
                onClick={() => resetForm()}
                size="sm"
                withIcon={true}
                icon={<FileOpenIcon width="18px" height="18px" />}
              />
            </div>
          </div>
          <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                {!isNull(formData?.id) ? (
                  <>
                    <MasterButton
                      type={"button"}
                      color="primary-cyan"
                      name={"Daftar Export"}
                      className="mt-1"
                      size="sm"
                      onClick={() =>
                        setShowModalExportList(!showModalExportList)
                      }
                      withIcon={true}
                      icon={<FormatListBulleted width="18px" height="18px" />}
                    />

                    <MasterButton
                      type={"button"}
                      color="warning"
                      name={isLoading ? "Loading..." : "Export Item Transaksi"}
                      disabled={isLoading}
                      className="mt-1"
                      size="sm"
                      onClick={handleExport}
                      withIcon={true}
                      icon={<CloudDownload width="18px" height="18px" />}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>

            {showModalExportList && (
              <ModalExportList
                title={"Export Daftar Item Pembelian"}
                showModal={() => setShowModalExportList(false)}
                type="LaporanTransaksiPembelianLogistik"
                service={BASE_URL_4}
              />
            )}
        </div>
      </div>
    </>
  )
}
